import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DealCycleRequest, DealCycleResponse } from '../models/deal-cycle.model';

@Injectable({ providedIn: 'root' })
export class DealCycleApiService {
  private readonly apiUrl = `${environment.apiUrl}api/deal-cycles`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<DealCycleResponse[]> {
    return this.http.get<DealCycleResponse[]>(this.apiUrl);
  }

  getById(id: number): Observable<DealCycleResponse> {
    return this.http.get<DealCycleResponse>(`${this.apiUrl}/${id}`);
  }

  create(req: DealCycleRequest): Observable<DealCycleResponse> {
    return this.http.post<DealCycleResponse>(this.apiUrl, req);
  }

  update(id: number, req: DealCycleRequest): Observable<DealCycleResponse> {
    return this.http.put<DealCycleResponse>(`${this.apiUrl}/${id}`, req);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
